import React from 'react';

import { SVGComponentProps } from './svg.types';

const UpvoteSVG = ({ fill = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M2.62502 4.81415V13.1252C2.62502 13.3571 2.53285 13.5797 2.36881 13.7438C2.20468 13.9078 1.98216 14 1.75017 14H0.875332C0.643343 14 0.420813 13.9078 0.256692 13.7438C0.0926593 13.5797 0.000488281 13.3571 0.000488281 13.1252V4.81415C0.000488281 4.58216 0.0926593 4.35963 0.256692 4.19551C0.420823 4.03147 0.643348 3.9393 0.875332 3.9393H1.75017C1.98216 3.9393 2.20469 4.03147 2.36881 4.19551C2.53285 4.35964 2.62502 4.58216 2.62502 4.81415ZM13.5951 6.17553C13.1881 5.59263 12.5204 5.24717 11.8095 5.25157H9.30422C9.81498 4.23535 10.1667 3.14677 10.347 2.0239C10.4301 1.52261 10.2882 1.0101 9.95908 0.622871C9.62604 0.228217 9.13598 0.000332832 8.61947 3.28855e-05H8.61732H8.61742C8.20449 -0.00250566 7.80419 0.142 7.48802 0.407585C7.17195 0.673262 6.96067 1.04272 6.89203 1.44977C6.71862 2.48356 6.21362 4.33101 4.77238 5.25159H3.49986V12.869L3.80908 13.1782C4.05464 13.4251 4.38875 13.5636 4.73694 13.5627H10.7291C11.091 13.5623 11.444 13.4499 11.7395 13.2409C12.035 13.0318 12.2585 12.7364 12.3793 12.3952L13.8718 8.16674C14.1124 7.49791 14.0089 6.75352 13.595 6.1757L13.5951 6.17553Z"
        fill={fill}
      />
    </svg>
  );
};

export default UpvoteSVG;
